import React from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { pickImplementation } from 'Helpers/Affordances';
import fr from 'facet-rest';
import DefaultClientSchedulerModal from './Default';

const ClientSchedulerModal = (props) => {
  const { householdResource } = useSimpleHousehold();
  return pickImplementation(householdResource, {
    [fr.relationships.default.name]: <DefaultClientSchedulerModal {...props} />,
  });
};

export default ClientSchedulerModal;
